import script from "./BuyerDashboardWorkersByCountryBarChart.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyerDashboardWorkersByCountryBarChart.vue?vue&type=script&setup=true&lang=js"

import "./BuyerDashboardWorkersByCountryBarChart.vue?vue&type=style&index=0&id=2b80b541&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b80b541"]])

export default __exports__